import { render, staticRenderFns } from "./RiscossioneList.vue?vue&type=template&id=ec6ec342&"
import script from "./RiscossioneList.vue?vue&type=script&lang=ts&"
export * from "./RiscossioneList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports